export class ConfirmDialogData {
  message: string;
}
